import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { OffersEditorComponent } from 'app/offers-editor/offers-editor.component';
import { SubvensionsEditorComponent } from 'app/subvensions-editor/subvensions-editor.component';
import { AuthComponent } from 'app/auth/auth.component';
import { MapComponent } from 'app/map/map.component';
import { RegisterPageComponent } from 'app/register-page/register-page.component';
import { NewOfferComponent } from 'app/new-offer/new-offer.component';



const routes: Routes = [
  { path: 'main', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: MapComponent },
  { path: 'login', component: AuthComponent },
  { path: 'register', component: RegisterPageComponent },
  { path: 'offers', component: OffersEditorComponent },
  { path: 'new', component: NewOfferComponent },
  { path: 'subvensions', component: SubvensionsEditorComponent },
  { path: 'offers/:id', component: OffersEditorComponent },
  { path: 'subvensions/:id', component: SubvensionsEditorComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/app-routing.module.ts